// @flow
export const UPDATE_BOOKING = 'booking/SUBMIT'
export const SUCCESS_BOOKING = 'booking/SUCCESS'

const booking = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_BOOKING:
      return {
        ...state,
        ...action.payload
      }
    case SUCCESS_BOOKING:
      return {
        ...action.payload
      }
    default:
      return state
  }
}

export const updateBooking = values => {
  return {
    type: UPDATE_BOOKING,
    payload: {
      ...values
    }
  }
}

export const successBooking = () => {
  return {
    type: SUCCESS_BOOKING,
    payload: {}
  }
}

export default booking
export * from './sagas.js'



// WEBPACK FOOTER //
// ./src/ducks/booking/index.js